exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.date-picker-custom[data-v-4b13811a] {\n  max-width: 290px;\n  min-width: 290px;\n  float: right;\n}\n.date-picker-custom *[data-v-4b13811a] {\n    color: #2e038c !important;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/components/date-picker-range/styles.scss"],"names":[],"mappings":";AAAA;EACE,iBAAgB;EAChB,iBAAgB;EAChB,aAAY;CAIb;AAPD;IAKI,0BAAyB;CAC1B","file":"styles.scss","sourcesContent":[".date-picker-custom {\n  max-width: 290px;\n  min-width: 290px;\n  float: right;\n  * {\n    color: #2e038c !important;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b13811a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/date-picker-range/styles.scss
// module id = I2E+
// module chunks = 0